import { render, staticRenderFns } from "./ekyc.vue?vue&type=template&id=145f70fe&"
import script from "./ekyc.vue?vue&type=script&lang=js&"
export * from "./ekyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports